const TEHRAN = 'Asia/Tehran';

const persianDate = new Intl.DateTimeFormat('fa-IR-u-ca-persian', {
    timeZone: TEHRAN, year: 'numeric', month: '2-digit', day: '2-digit',
});
const persianDateTime = new Intl.DateTimeFormat('fa-IR-u-ca-persian', {
    timeZone: TEHRAN, year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
});
const tehranParts = new Intl.DateTimeFormat('en-US-u-ca-gregory', {
    timeZone: TEHRAN, year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23',
});
const tehranDay = new Intl.DateTimeFormat('en-CA-u-ca-gregory', {
    timeZone: TEHRAN, year: 'numeric', month: '2-digit', day: '2-digit',
});

// PHP stores wall time in Tehran without a timezone suffix. Parse it without
// relying on the administrator's device timezone.
export const parseTehranDate = (value?: string | null): Date | null => {
    if (!value) return null;
    const input = value.trim();
    const match = /^(\d{4})[-/](\d{2})[-/](\d{2})(?:[ T](\d{2}):(\d{2})(?::(\d{2})(?:\.\d+)?)?)?$/.exec(input);
    if (!match) {
        const date = new Date(input);
        return Number.isNaN(date.getTime()) ? null : date;
    }
    const [, year, month, day, hour = '12', minute = '00', second = '00'] = match;
    if (match[4] === undefined) {
        const date = new Date(Date.UTC(+year, +month - 1, +day, 12));
        return Number.isNaN(date.getTime()) ? null : date;
    }
    const wallUtc = Date.UTC(+year, +month - 1, +day, +hour, +minute, +second);
    let instant = wallUtc - 3.5 * 60 * 60 * 1000;
    // The IANA zone database resolves historical daylight saving offsets.
    for (let attempt = 0; attempt < 3; attempt++) {
        const parts = Object.fromEntries(tehranParts.formatToParts(new Date(instant)).map(part => [part.type, part.value]));
        const renderedWall = Date.UTC(+parts.year, +parts.month - 1, +parts.day, +parts.hour, +parts.minute, +parts.second);
        const difference = wallUtc - renderedWall;
        if (!difference) break;
        instant += difference;
    }
    const date = new Date(instant);
    return Number.isNaN(date.getTime()) ? null : date;
};

export const getTehranDateKey = (date: Date): string => {
    const parts = Object.fromEntries(tehranDay.formatToParts(date).map(part => [part.type, part.value]));
    return `${parts.year}-${parts.month}-${parts.day}`;
};

export const formatPersianDate = (date: Date): string => persianDate.format(date);

export const formatPersianDateTime = (value?: string | null): string => {
    const date = parseTehranDate(value);
    return date ? persianDateTime.format(date) : (value || 'بدون تاریخ');
};

export const convertToShamsi = (value: string): string => {
    if (!value) return '';
    if (/^1[34]\d{2}[-/]\d{1,2}[-/]\d{1,2}$/.test(value.trim())) return value;
    const date = parseTehranDate(value);
    return date ? new Intl.DateTimeFormat('fa-IR-u-ca-persian', {
        timeZone: TEHRAN, year: 'numeric', month: 'long', day: 'numeric',
    }).format(date) : value;
};
